export const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP';
export const INIT_STEPPER = 'INIT_STEPPER';
export const UPDATE_STATE_STEPPER = 'UPDATE_STATE_STEPPER';
